import { AnyAction } from 'redux';
import { AntragsnummerGeneratedAction, UnfActions } from '../unfActions';
import { IAppState } from '../appState';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: AnyAction,
  appState: IAppState,
): IAppState['antragsnummer'] {
  switch (action.type) {
    case UnfActions.ANTRAGSNUMMER_GENERATED:
      return action.payload.angebotsId === appState.angebotsId
        ? (action as AntragsnummerGeneratedAction).payload.antragsnummer
        : sectionState;
    default:
      return sectionState;
  }
};
